import { ShareLinkSelectedCommentTarget } from "./share-link-selected-comment-target"

export function ShareLinkSelectedTaskCommentTarget({ children }) {
    return <ShareLinkSelectedCommentTarget targetType="task">{children}</ShareLinkSelectedCommentTarget>
}
